import { render, staticRenderFns } from "./FilterSchoolSearch.vue?vue&type=template&id=a500059e&scoped=true&"
import script from "./FilterSchoolSearch.vue?vue&type=script&lang=ts&"
export * from "./FilterSchoolSearch.vue?vue&type=script&lang=ts&"
import style0 from "./FilterSchoolSearch.vue?vue&type=style&index=0&id=a500059e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a500059e",
  null
  
)

export default component.exports